import type { FieldDefinition } from '@/data/schemas';
import { formatIsoDateDDMMYYYY, formatMonthYear } from '@/utils/date';

export function formatValue(value: unknown, field: FieldDefinition, locale: string): string {
  if (value === null || value === undefined) {
    if (field.type === 'bool' && field.formatting?.labels?.null) {
      return field.formatting.labels.null;
    }
    return '';
  }

  switch (field.type) {
    case 'bool': {
      const labels = field.formatting?.labels;
      if (value === true) return labels?.true ?? 'Sì';
      if (value === false) return labels?.false ?? 'No';
      return labels?.null ?? '';
    }
    case 'date': {
      if (typeof value !== 'string') return String(value);
      const display = field.formatting?.display ?? 'default';
      if (display === 'month-year') {
        return formatMonthYear(value, locale);
      }
      return formatIsoDateDDMMYYYY(value);
    }
    case 'number': {
      if (typeof value !== 'number') {
        const parsed = parseFloat(String(value));
        if (isNaN(parsed)) return String(value);
        value = parsed;
      }
      const options: Intl.NumberFormatOptions = {};
      if (field.formatting?.maximumFractionDigits !== undefined) {
        options.maximumFractionDigits = field.formatting.maximumFractionDigits;
      }
      const formatted = (value as number).toLocaleString(locale, options);
      const unit = field.formatting?.unit;
      return unit ? `${formatted} ${unit}` : formatted;
    }
    default:
      return String(value);
  }
}

export function getDefaultValue(type: FieldDefinition['type']): unknown {
  switch (type) {
    case 'number':
      return 0;
    case 'bool':
      return null;
    case 'date':
      return '';
    default:
      return '';
  }
}
